import { showProcessingOverlay } from "./processing_overlay"

// Tela de "processando" dos checkouts (parceiro, venda direta, e-commerce).
// O desenho é o mesmo de qualquer espera longa (ver processing_overlay); aqui
// ficam só os textos e o id que os checkouts já usam.
export function showPaymentProcessingOverlay({
  title = "Processando pagamento",
  subtitle = "Estamos processando com segurança. Não feche esta janela."
} = {}) {
  return showProcessingOverlay({ id: "payment-processing-overlay", title: title, subtitle: subtitle })
}
